module.exports = __webpack_public_path__ + "static/media/placeholder-bigbanner.e7419d65.svg";